export const actionTypes = {
  CHANGE_THEME: 'CHANGE_THEME',
};

export const changeColor = (colorSet) => ({
  type: actionTypes.CHANGE_THEME,
  colorSet,
});
